import { render, staticRenderFns } from "./DataSummary.vue?vue&type=template&id=6e3a4f3e&scoped=true"
import script from "./DataSummary.vue?vue&type=script&setup=true&lang=js"
export * from "./DataSummary.vue?vue&type=script&setup=true&lang=js"
import style0 from "./DataSummary.vue?vue&type=style&index=0&id=6e3a4f3e&prod&lang=postcss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e3a4f3e",
  null
  
)

export default component.exports